import {Modal} from "antd";
import React from "react";
import icon from "../../../assets/images/modal-icon-offer.svg";
import {FormValuesOtp} from "../../../core/models/custom/formValuesOtp";
import FirebaseService from "../../../core/services/firebaseService/firebase.service";
import {UI} from "../../../core/utilities/ui";
import FirebaseKey from "../../FirebaseKey/FirebaseKey";
import OtpForm from "./OtpForm/OtpForm";
import "./OtpModal.scss";

interface IProps {
  isLoading: boolean;
  callbackSubmit: (values?: FormValuesOtp) => void;
  callbackNewCode: () => void;
}

const OtpModal = (props: IProps) => {
  
  return (
    <Modal
      className="otp-modal"
      maskStyle={UI.modalMaskStyle()}
      visible
      closable={false}
      footer={false}
      centered
      destroyOnClose
    >
      <div className="content">
        <img className="icon" src={icon} alt="icon"/>
        <FirebaseKey className="title" firebaseKey={FirebaseService.mobile_payment_otp_popup_title}/>
        <FirebaseKey className="text" firebaseKey={FirebaseService.mobile_payment_otp_popup_desc}/>
        <OtpForm
          isLoading={props.isLoading}
          callbackSubmit={props.callbackSubmit}
          callbackNewCode={props.callbackNewCode}
        />
      </div>
    </Modal>
  );
}

export default OtpModal;
